import { d as defineCustomElement$1 } from './p-B_fGLL9P.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.4.1
 */
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-page-header-nav.js.map
